import script from "./psiStockGoodsAdjustPriceOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./psiStockGoodsAdjustPriceOrder.vue?vue&type=script&setup=true&lang=js"

import "./psiStockGoodsAdjustPriceOrder.vue?vue&type=style&index=0&id=eda531d6&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eda531d6"]])

export default __exports__